import { format } from 'node:util';

const PatternMessages = {
    MISSING_CLOSE_CAPTURE: "Expected close capture character after variable name '}'",
    MISSING_OPEN_CAPTURE: "Missing preceding open capture character before variable name'{'",
    ILLEGAL_NESTED_CAPTURE: "Not allowed to nest variable captures",
    CANNOT_HAVE_ADJACENT_CAPTURES: "Adjacent captures are not allowed",
    ILLEGAL_CHARACTER_AT_START_OF_CAPTURE_DESCRIPTOR: "Char '%s' not allowed at start of captured variable name",
    ILLEGAL_CHARACTER_IN_CAPTURE_DESCRIPTOR: "Char '%s' is not allowed in a captured variable name",
    CANNOT_HAVE_MANY_MULTISEGMENT_PATH_ELEMENTS: "Multiple '{*...}' or '**' pattern elements are not allowed",
    INVALID_LOCATION_FOR_MULTISEGMENT_PATH_ELEMENT: "'{*...}' or '**' pattern elements should be placed at the start or end of the pattern",
    MISSING_REGEX_CONSTRAINT: "Missing regex constraint on capture",
    ILLEGAL_DOUBLE_CAPTURE: "Not allowed to capture ''{0}'' twice in the same pattern",
    REGEX_PATTERN_SYNTAX_EXCEPTION: "Exception occurred in regex pattern compilation",
    CAPTURE_ALL_IS_STANDALONE_CONSTRUCT: "'{*...}' cannot be mixed with other path elements in the same path segment",
}

export type PatternMessage = keyof typeof PatternMessages;

export class PatternParseError extends Error {

    readonly position: number;
    readonly messageType: PatternMessage;
    readonly inserts: readonly unknown[];
    readonly #pattern: Uint16Array;

    static formatMessage(messageType: PatternMessage, inserts: readonly unknown[]): string {
        return format(PatternMessages[messageType], ...inserts);
    }

    /* internal */ static createWithCause(cause: Error,
                                  position: number,
                                  pattern: Uint16Array,
                                  messageType: PatternMessage,
                                  ...inserts: readonly unknown[]): PatternParseError {
        const message = PatternParseError.formatMessage(messageType, inserts);
        return new PatternParseError(position, pattern, messageType, inserts, message, { cause });
    }

    /* internal */ static create(pos: number, pattern: Uint16Array, messageType: PatternMessage, ...inserts: readonly unknown[]): PatternParseError {
        const message = PatternParseError.formatMessage(messageType, inserts);
        return new PatternParseError(pos, pattern, messageType, inserts, message);
    }

    private constructor(
        pos: number,
        pattern: Uint16Array,
        messageType: PatternMessage,
        inserts: readonly unknown[],
        message: string,
        options?: { cause?: Error },
    ) {
        super(message, options);
        this.position = pos;
        this.#pattern = pattern;
        this.messageType = messageType;
        this.inserts = inserts;
    }

    toDetailedString(): string {
        const sb: string[] = [];
        sb.push(String.fromCharCode(...this.#pattern));
        sb.push('\n');
        for (let i = 0; i < Math.max(0, this.position); i++) {
            sb.push(' ');
        }
        sb.push('^\n');
        sb.push(this.message);
        return sb.join('');
    }
}
